import React, { forwardRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import cn from 'classnames';
import './style.scss';

const DatePickerWrapper = ({
  onChange,
  defaultValue,
  minDate,
  trackingId = null,
}) => {
  const [dateValue, setDateValue] = useState(defaultValue);

  useEffect(() => {
    onChange(dateValue);
  }, [dateValue]);

  useEffect(() => {
    setDateValue(defaultValue);
  }, [defaultValue]);

  const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <div
      role="button"
      tabIndex="0"
      ref={ref}
      className={cn(
        'datepicker__input--custom',
        'ft-amf-date-picker-control',
        'border',
        'border-gray-400',
        'rounded-24.8',
        'h-12.2',
        'pl-6',
        'pr-6',
      )}
      onClick={onClick}
      data-tracking-id={trackingId}
    >
      <div className="mr-10">{value}</div>
      <Icon id="calendar" />
    </div>
  ));

  return (
    <div className="date-picker-wrapper">
      <DatePicker
        selected={dateValue}
        onChange={(date) => setDateValue(date)}
        customInput={<DatePickerInput />}
        minDate={minDate}
      />
    </div>
  );
};

export default DatePickerWrapper;
